import { createState } from '~/src/hooks/useEoState'
import { Announcement } from '@eo-storefronts/eo-core'

export const ANNOUNCEMENTS = createState<Announcement[]>({
  key: 'announcements',
  default: []
})
